<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14X2TWD/tc-custom/9781429941952.jpg?1728259128886" alt="This image is the cover for the book Dead Spy Running, The Daniel Marchant Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dead Spy Running, The Daniel Marchant Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <p>Daniel Marchant, a suspended MI6 officer, is running the London Marathon. He is also running out of time. A competitor is strapped with explosives, and if he drops his pace, everyone around him will be killed, including the U.S. ambassador to London. <br/><br/> Marchant tries to thwart the attack, but is he secretly working for the terrorists? There are those who already suspect him of treachery. Just like they suspected his late father, the former head of MI6, who was removed from his job and accused of treason. <br/><br/> On the run from the CIA, Marchant is determined to prove his father's innocence. His quest to do so takes him from the streets of London to India, where the U.S. president is due for his first visit. Marchant soon finds that to clear his family's name he will have to expose a plot that could throw world politics into chaos. <br/><br/> In <i>Dead Spy Running</i>, Jon Stock delivers a breakneck thriller that updates the spy novel for the twenty-first century.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jon Stock
      </h2>
      
      <p class="authorDescription body article"><P>JON STOCK has worked as a freelance journalist in London, writing features for most of Britain's national newspapers, as well as contributing to <I>BBC Radio 4</I>. Between 1998 and 2000, he was Delhi correspondent for the <I>Daily Telegraph</I>. On his return to Britain, he worked on various Saturday sections of the paper before taking up a staff job as editor of <I>Weekend</I> in 2005. He has been writing the Last Word column for <I>The Week </I>in India ever since he lived in Cochin, Kerala, in 1995. He is married, with three children, and lives in Wiltshire, United Kingdom.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Macmillan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?89ab6190